const options = {
  5: "bg-teal-600/5",
  10: "bg-teal-600/10",
  25: "bg-teal-600/25",
  50: "bg-teal-600/50",
  75: "bg-teal-600/75",
  90: "bg-teal-600/90",
  100: "bg-teal-600",
};

const from = {
  5: "from-teal-600/5",
  10: "from-teal-600/10",
  25: "from-teal-600/25",
  50: "from-teal-600/50",
  75: "from-teal-600/75",
  90: "from-teal-600/90",
  100: "from-teal-600",
};

export default function getBackgroundTeal600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
